import { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { useParams } from "react-router-dom";
import { Label, TextInput, Card } from "flowbite-react";
import { useGetData } from "../../../../../hooks/useGetData";
import { API } from "../../../../../global/global";
import Semaforo from "../../../../../img/Semaforo.png";
import Rojo from "../../../../../img/Rojo.png";
import Amarillo from "../../../../../img/Amarillo.png";
import Verde from "../../../../../img/Verde.png";
import { EvaluadoInterface } from "../../../../../interfaces/EvaluadoInterface";
import { FechaSocioeconomicaInterface } from "../../../../../interfaces/FechaSocioeconomicaInterface";
import { ConclusionLlenadaSEInterface } from "../../../../../interfaces/ConclusionLlenadaSEInterface";
import { ResultadoSEInterface } from "../../../../../interfaces/ResultadoSEInterface";
import { SemaforoSEInterface } from "../../../../../interfaces/SemaforoSEInterface";
import HeaderPrint from "../../../../../components/HeaderFormsPrint/HeaderFormsPrint";
import fotoMapa from "../../../../../img/fotoMapa.png";

export const ConclusionesSEListaPrint = () => {
  const tituloFormulario =
    "CONCLUSIONES DE EVALUACIÓN DE INVESTIGACIÓN SOCIOECONÓMICA Y/O PATRIMONIAL";
  const { control, reset } = useForm();
  const { evaluadosList_id } = useParams<{ evaluadosList_id: string }>();
  const [edad, setEdad] = useState<number | null>(null);
  const [fechaNacimiento, setFechaNacimiento] = useState<string>("");
  const [photoUrl, setPhotoUrl] = useState<string | null>(null);

  const formFields = [
    { label: "NOMBRE:", id: "nombre" },
    { label: "DOMICILIO:", id: "domicilio" },
    { label: "TELÉFONO:", id: "telefono" },
    { label: "OCUPACIÓN:", id: "ocupacion" },
    { label: "AÑOS DE CONOCER AL EVALUADO:", id: "anios-conocerlo" },
    { label: "COMENTARIOS:", id: "comentarios" },
    { label: "LO RECOMIENDA:", id: "como-conoce" },
  ];

  const [formData, setFormData] = useState({});

  const handleInputChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const calcularEdad = (fechaNacimiento: string) => {
    const fechaNac = new Date(fechaNacimiento);
    const hoy = new Date();
    let edadCalculada = hoy.getFullYear() - fechaNac.getFullYear();
    const mes = hoy.getMonth() - fechaNac.getMonth();

    if (mes < 0 || (mes === 0 && hoy.getDate() < fechaNac.getDate())) {
      edadCalculada--;
    }

    return edadCalculada;
  };

  const handleFechaNacimientoChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const nuevaFechaNacimiento = event.target.value;
    setFechaNacimiento(nuevaFechaNacimiento);

    const nuevaEdad = calcularEdad(nuevaFechaNacimiento);
    setEdad(nuevaEdad);
  };

  const queryEvaluado = useGetData<EvaluadoInterface>({
    url: `/evaluado/${evaluadosList_id}`,
    name: ["evaluado"],
  });

  const queryFechaSE = useGetData<FechaSocioeconomicaInterface[]>({
    url: `/fecha-socioeconomica/${evaluadosList_id}`,
    name: ["evaluado", `${evaluadosList_id}`, "fecha-socioeconomica"],
  });

  const queryConclusionSE = useGetData<ConclusionLlenadaSEInterface>({
    url: `/conclusionllenada_se/${evaluadosList_id}`,
    name: ["evaluado", `${evaluadosList_id}`, "conclusionllenada_se"],
  });

  const queryResultadoSE = useGetData<ResultadoSEInterface[]>({
    url: `/resultado-conclusionse/${evaluadosList_id}`,
    name: ["evaluado", `${evaluadosList_id}`, "resultado-conclusionse"],
  });

  const querySemaforoSE = useGetData<SemaforoSEInterface>({
    url: `/semaforose/${evaluadosList_id}`,
    name: ["evaluado", `${evaluadosList_id}`, "semaforose"],
  });

  const generoMap: { [key: string]: string } = {
    M: "Masculino",
    F: "Femenino",
    O: "Otro",
  };

  const normalizeString = (str: string) => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  };

  const nombreCompleto = normalizeString(
    `${queryEvaluado.data?.nombre}_${queryEvaluado.data?.apellido_paterno}_${queryEvaluado.data?.apellido_materno}`.replace(
      /\s/g,
      "_"
    )
  );

  const [selectedImage, setSelectedImage] = useState(Semaforo);
  const [selectedRecommendation, setSelectedRecommendation] = useState<
    string | null
  >(null);

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setSelectedRecommendation(value);

    if (value === "recomendable") {
      setSelectedImage(Verde);
    } else if (value === "con_reserva") {
      setSelectedImage(Amarillo);
    } else if (value === "no_recomendable") {
      setSelectedImage(Rojo);
    }
  };

  const generoTexto =
    generoMap[queryEvaluado.data?.genero as string] || "No especificado";

  const totalGastos = queryConclusionSE.data
    ? [
        queryConclusionSE.data.gastoalimentacion_se,
        queryConclusionSE.data.gastovestido_se,
        queryConclusionSE.data.gastogasolina_se,
        queryConclusionSE.data.gastotransporte_se,
        queryConclusionSE.data.gastotelefono_se,
        queryConclusionSE.data.gastodiversiones_se,
        queryConclusionSE.data.gastoautofinanciamiento_se,
        queryConclusionSE.data.gastootros1_se,
        queryConclusionSE.data.gastohipoteca_se,
        queryConclusionSE.data.gastorenta_se,
        queryConclusionSE.data.gastocolegiaturas_se,
        queryConclusionSE.data.gastoservicios_se,
        queryConclusionSE.data.gastodeudas_se,
        queryConclusionSE.data.gastoinversiones_se,
        queryConclusionSE.data.gastopension_se,
        queryConclusionSE.data.gastootros2_se,
      ].reduce((acc, curr) => acc + Number(curr || 0), 0)
    : 0;

  useEffect(() => {
    console.log(queryEvaluado.data);
    if (queryEvaluado.data) {
      const fechaNac = queryEvaluado.data.fecha_nacimiento || "";
      setFechaNacimiento(fechaNac);

      const nuevaEdad = calcularEdad(fechaNac);
      setEdad(nuevaEdad);

      reset({
        nombre: queryEvaluado.data.nombre || "",
        apellido_paterno: queryEvaluado.data.apellido_paterno || "",
        apellido_materno: queryEvaluado.data.apellido_materno || "",
        rfc: queryEvaluado.data.rfc || "",
        genero: queryEvaluado.data.genero || "",
        estado_civil: queryEvaluado.data.estado_civil || "",
        escolaridad: queryEvaluado.data.escolaridad || "",
        fecha_nacimiento: queryEvaluado.data.fecha_nacimiento || "",
        curp: queryEvaluado.data.curp || "",
        empresa: queryEvaluado.data.empresa?.nombre || "",
      });
    }
  }, [queryEvaluado.data, reset]);

  useEffect(() => {
    if (evaluadosList_id) {
      const token = localStorage.getItem("token");
      fetch(`${API}/evaluados/${evaluadosList_id}/photo/${nombreCompleto}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.url) {
            setPhotoUrl(data.url);
            console.log("URL de la foto:", data.url);
          } else {
            setPhotoUrl(null);
          }
        })
        .catch((error) => {
          console.error("Error al obtener la URL de la foto:", error);
          setPhotoUrl(null);
        });
    }
  }, [evaluadosList_id, nombreCompleto]);

  useEffect(() => {
    if (queryFechaSE.data && queryFechaSE.data.length > 0) {
      const fechase = queryFechaSE.data[0];
      reset({
        fecha_autorizacionse: fechase.fecha_autorizacionse || "",
      });
    }
  }, [queryFechaSE.data, reset]);

  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    if (querySemaforoSE.data) {
      const color = querySemaforoSE.data.color_se || "";

      let recommendation = "";
      if (color === "verde") {
        recommendation = "recomendable";
      } else if (color === "amarillo") {
        recommendation = "con_reserva";
      } else if (color === "rojo") {
        recommendation = "no_recomendable";
      }

      reset({
        color_ps: color,
        evaluado_uuid: querySemaforoSE.data.evaluado_uuid || "",
      });

      setSelectedRecommendation(recommendation);
      setIsReady(true);

      if (recommendation === "recomendable") {
        setSelectedImage(Verde);
      } else if (recommendation === "con_reserva") {
        setSelectedImage(Amarillo);
      } else if (recommendation === "no_recomendable") {
        setSelectedImage(Rojo);
      }
    }
  }, [querySemaforoSE.data, reset]);

  useEffect(() => {
    if (queryConclusionSE.data) {
      reset({
        derivado_se: queryConclusionSE.data.derivado_se || "",
        regimen_se: queryConclusionSE.data.regimen_se || "",
        anioscasado_se: queryConclusionSE.data.anioscasado_se || "",
        numhijos_se: queryConclusionSE.data.numhijos_se || "",
        edadhijos_se: queryConclusionSE.data.edadhijos_se || "",
        numdependientes_se: queryConclusionSE.data.numdependientes_se || "",
        quienesdependen_se: queryConclusionSE.data.quienesdependen_se || "",
        aniostrabajando_se: queryConclusionSE.data.aniostrabajando_se || "",
        areapertenece_se: queryConclusionSE.data.areapertenece_se || "",
        fechalaborando_se: queryConclusionSE.data.fechalaborando_se || "",
        enterovacante_se: queryConclusionSE.data.enterovacante_se || "",
        recomendo_se: queryConclusionSE.data.recomendo_se || "",
        gastoalimentacion_se: queryConclusionSE.data.gastoalimentacion_se || "",
        gastovestido_se: queryConclusionSE.data.gastovestido_se || "",
        gastogasolina_se: queryConclusionSE.data.gastogasolina_se || "",
        gastotransporte_se: queryConclusionSE.data.gastotransporte_se || "",
        gastotelefono_se: queryConclusionSE.data.gastotelefono_se || "",
        gastodiversiones_se: queryConclusionSE.data.gastodiversiones_se || "",
        gastoautofinanciamiento_se:
          queryConclusionSE.data.gastoautofinanciamiento_se || "",
        gastootros1_se: queryConclusionSE.data.gastootros1_se || "",
        gastohipoteca_se: queryConclusionSE.data.gastohipoteca_se || "",
        gastorenta_se: queryConclusionSE.data.gastorenta_se || "",
        gastocolegiaturas_se: queryConclusionSE.data.gastocolegiaturas_se || "",
        gastoservicios_se: queryConclusionSE.data.gastoservicios_se || "",
        gastodeudas_se: queryConclusionSE.data.gastodeudas_se || "",
        gastoinversiones_se: queryConclusionSE.data.gastoinversiones_se || "",
        gastopension_se: queryConclusionSE.data.gastopension_se || "",
        gastootros2_se: queryConclusionSE.data.gastootros2_se || "",
        gastototal_se: queryConclusionSE.data.gastototal_se || "",
        ingresomensual_se: queryConclusionSE.data.ingresomensual_se || "",
        compuestopor_se: queryConclusionSE.data.compuestopor_se || "",
        ingresoesposa_se: queryConclusionSE.data.ingresoesposa_se || "",
        ingresosextra_se: queryConclusionSE.data.ingresosextra_se || "",
        ascienden_se: queryConclusionSE.data.ascienden_se || "",
        egresosfam_se: queryConclusionSE.data.egresosfam_se || "",
        compuestosde_se: queryConclusionSE.data.compuestosde_se || "",
        esposaegreso_se: queryConclusionSE.data.esposaegreso_se || "",
        deudasascienden1_se: queryConclusionSE.data.deudasascienden1_se || "",
        gastosaprox_se: queryConclusionSE.data.gastosaprox_se || "",
        deudasascienden2_se: queryConclusionSE.data.deudasascienden2_se || "",
        cuantosvehiculos_se: queryConclusionSE.data.cuantosvehiculos_se || "",
        marcavechiculo_se: queryConclusionSE.data.marcavechiculo_se || "",
        aniovehiculo_se: queryConclusionSE.data.aniovehiculo_se || "",
        adquiriovehiculo_se: queryConclusionSE.data.adquiriovehiculo_se || "",
        domicilioactual_se: queryConclusionSE.data.domicilioactual_se || "",
        tiempoviviendo_se: queryConclusionSE.data.tiempoviviendo_se || "",
        referenciavecinal1_se:
          queryConclusionSE.data.referenciavecinal1_se || "",
        referenciavecinal2_se:
          queryConclusionSE.data.referenciavecinal2_se || "",
        titularcuentabanco_se:
          queryConclusionSE.data.titularcuentabanco_se || "",
        tiempolibre_se: queryConclusionSE.data.tiempolibre_se || "",
        fuma_se: queryConclusionSE.data.fuma_se || "",
        cuantofuma_se: queryConclusionSE.data.cuantofuma_se || "",
        toma_se: queryConclusionSE.data.toma_se || "",
        cuantotoma_se: queryConclusionSE.data.cuantotoma_se || "",
        ultimavez_se: queryConclusionSE.data.ultimavez_se || "",
        consumedrogas_se: queryConclusionSE.data.consumedrogas_se || "",
        aniolaboral_se: queryConclusionSE.data.aniolaboral_se || "",
        externo1_se: queryConclusionSE.data.externo1_se || "",
        tiempolaborando1_se: queryConclusionSE.data.tiempolaborando1_se || "",
        tiempolaborando2_se: queryConclusionSE.data.tiempolaborando2_se || "",
        supervision_se: queryConclusionSE.data.supervision_se || "",
        telcoordinadora_se: queryConclusionSE.data.telcoordinadora_se || "",
        telsinexito_se: queryConclusionSE.data.telsinexito_se || "",
        externo2_se: queryConclusionSE.data.externo2_se || "",
        observaciones_se: queryConclusionSE.data.observaciones_se || "",
        drogasdescripcion_se: queryConclusionSE.data.drogasdescripcion_se || "",
      });
    }
  }, [queryConclusionSE.data, reset]);

  useEffect(() => {
    if (queryResultadoSE.data && queryResultadoSE.data.length > 0) {
      const resultado = queryResultadoSE.data[0];
      reset({
        resultado_conclusion: resultado.resultado_conclusion || "",
      });
    }
  }, [queryResultadoSE.data, reset]);

  return (
    <div className="max-w-[800px] mx-auto p-4 bg-white">
      {/* Marca de agua */}
      <div className="absolute inset-0 flex justify-center items-center pointer-events-none z-0">
        <div
          className="text-blue-500 text-9xl font-bold transform rotate-[-48deg]"
          style={{ opacity: 0.1 }}
        >
          CONFIDENCIAL
        </div>
      </div>
      {/* Header */}
      <HeaderPrint titulo={tituloFormulario} />
      {/* Título del formulario */}
      <div id="headerContent" className="text-center">
        <h1
          className="text-black text-xl font-bold py-3 px-8 rounded-b-md inline-block shadow-lg flex justify-center transition-transform duration-300 ease-in-out hover:scale-105 cursor-pointer"
          style={{
            backgroundImage: `url(${fotoMapa})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          {tituloFormulario}
        </h1>
      </div>
      <div className="space-y-1 p-1 mt-2">
        <div className="grid grid-cols-3 gap-2">
          <div className="col-span-1 flex items-center">
            <Label htmlFor="fecha_bienesinmuebles" className="mr-2">
              FECHA:
            </Label>
            <Controller
              name="fecha_conclusionps"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <input
                  id="fecha_conclusionps"
                  type="date"
                  value={
                    field.value ||
                    (queryFechaSE.data && queryFechaSE.data.length > 0
                      ? queryFechaSE.data[0]?.fecha_conclusionse || ""
                      : "")
                  }
                  onChange={(e) => field.onChange(e.target.value)}
                  disabled={true}
                  className="text-left w-auto border rounded"
                />
              )}
            />
          </div>
          <div className="col-span-2">
            <Label htmlFor="nombre">NOMBRE:</Label>
            <TextInput
              id="nombre"
              name="nombre"
              value={`${queryEvaluado.data?.nombre || ""} ${
                queryEvaluado.data?.apellido_paterno || ""
              } ${queryEvaluado.data?.apellido_materno || ""}`}
              onChange={handleInputChange}
              disabled={true}
            />
          </div>
        </div>
        <div className="grid grid-cols-3 gap-2">
          {/* FOTO */}
          <div className="w-40 h-40 border border-gray-300 rounded-md overflow-hidden bg-gray-100 flex items-center justify-center mt-4 relative z-10">
            {photoUrl ? (
              <img
                src={photoUrl}
                alt="Foto de evaluado"
                className="w-full h-full object-cover"
              />
            ) : (
              <span className="text-gray-500">Sin foto disponible</span>
            )}
          </div>
          {/* SEMAFORO */}
          <div className="flex items-center gap-4">
            {selectedRecommendation && (
              <>
                {/* Radio buttons */}
                <div className="flex flex-col">
                  <label className="flex items-center gap-2 mt-4 mb-4">
                    <input
                      type="radio"
                      name="recommendation"
                      value="recomendable"
                      checked={selectedRecommendation === "recomendable"}
                      onChange={handleRadioChange}
                      disabled={true}
                    />
                    RECOMENDABLE
                  </label>
                  <label className="flex items-center gap-2 mt-12 mb-12">
                    <input
                      type="radio"
                      name="recommendation"
                      value="con_reserva"
                      checked={selectedRecommendation === "con_reserva"}
                      onChange={handleRadioChange}
                      disabled={true}
                    />
                    CON RESERVA
                  </label>
                  <label className="flex items-center gap-2 mb-12">
                    <input
                      type="radio"
                      name="recommendation"
                      value="no_recomendable"
                      checked={selectedRecommendation === "no_recomendable"}
                      onChange={handleRadioChange}
                    />
                    NO RECOMENDABLE
                  </label>
                </div>
                {/* Imagen de Semaforo */}
                <img src={selectedImage} alt="Semaforo" className="w-70 h-70" />
              </>
            )}
          </div>
        </div>
        <div className="grid grid-cols-3 gap-2">
          {/* Campo para RFC */}
          <div className="col-span-1">
            <Label htmlFor="rfc">RFC:</Label>
            <TextInput
              id="rfc"
              name="rfc"
              onChange={handleInputChange}
              value={queryEvaluado.data?.rfc || ""}
              disabled={true}
            />
          </div>
          {/* Edad */}
          <div className="col-span-1">
            <Label htmlFor="edad">EDAD:</Label>
            <TextInput
              id="edad"
              name="edad"
              value={edad !== null ? edad.toString() : ""}
              disabled={true}
            />
          </div>
          <div className="col-span-1">
            <Label htmlFor="sexo">SEXO:</Label>
            <TextInput
              id="sexo"
              name="sexo"
              value={generoTexto}
              disabled={true}
            />
          </div>
          <div className="col-span-1">
            <Label htmlFor="estadoCivil">ESTADO CIVIL:</Label>
            <TextInput
              id="estadoCivil"
              name="estadoCivil"
              onChange={handleInputChange}
              value={`${queryEvaluado.data?.estado_civil || ""}`}
              disabled={true}
            />
          </div>
          <div className="col-span-1">
            <Label htmlFor="escolaridad">ESCOLARIDAD:</Label>
            <TextInput
              id="escolaridad"
              name="escolaridad"
              onChange={handleInputChange}
              value={`${queryEvaluado.data?.escolaridad || ""}`}
              disabled={true}
            />
          </div>
          <div className="col-span-1 flex items-center">
            <Label htmlFor="fechaNacimiento" className="mr-2">
              FECHA DE NACIMIENTO:
            </Label>
            <TextInput
              id="fechaNacimiento"
              name="fechaNacimiento"
              value={`${queryEvaluado.data?.fecha_nacimiento || ""}`}
              disabled={true}
              type="date"
              onChange={handleInputChange}
              className="w-32"
            />
          </div>
          <div className="col-span-1">
            <Label htmlFor="curp">CURP:</Label>
            <TextInput
              id="curp"
              name="curp"
              onChange={handleInputChange}
              value={queryEvaluado.data?.curp || ""}
              disabled={true}
            />
          </div>
          <div className="col-span-1">
            <Label htmlFor="empresa">EMPRESA:</Label>
            <TextInput
              id="empresa_id"
              name="empresa"
              value={queryEvaluado.data?.empresa_id?.nombre || ""}
              onChange={handleInputChange}
              disabled={true}
            />
          </div>
        </div>
      </div>
      <div className="mt-[250px]"></div>
      {/* Sección de Notas */}
      <div className="border border-gray-300 mt-4">
        <div className="bg-blue-100 p-2 text-center font-semibold text-gray-700 border-b border-gray-300">
          NOTAS
        </div>
        <div className="space-y-6 p-6 rounded-lg">
          <div className="bg-customBlue text-white p-4 rounded-lg shadow">
            <h2 className="font-bold text-xl">
              CONCLUSIONES DE EVALUACIONES DE INVESTIGACIÓN SOCIOECONÓMICA Y/O
              PATRIMONIAL
            </h2>
          </div>

          <div className="flex flex-col items-start border-dashed border-4 border-gray-300 rounded-lg p-6 bg-gray-50 space-y-6 relative">
            <p className="text-xl font-semibold text-gray-800">
              DATOS RELEVANTES
            </p>

            <p className="text-justify text-gray-800 leading-relaxed">
              Derivado de la valoración y revisión de la información, se
              considera que es una{" "}
              <strong>
                PERSONA {queryConclusionSE.data?.marcavechiculo_se}{" "}
              </strong>
              , en virtud de que al momento de la evaluación de la investigación
              socioeconómica se detectó:{" "}
              <Controller
                name="adquiriovehiculo_se"
                control={control}
                defaultValue={`${
                  queryConclusionSE.data?.adquiriovehiculo_se || ""
                }`}
                render={({ field }) => {
                  return (
                    <textarea
                      {...field}
                      id="adquiriovehiculo_se"
                      disabled={true}
                      className="w-full p-4 min-h-[150px] text-sm text-gray-900 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 placeholder-gray-400 resize-none"
                      aria-label="adquiriovehiculo_se"
                      placeholder="Escribe lo que detectarón aquí..."
                    />
                  );
                }}
              />
            </p>

            <p className="text-justify text-gray-800 leading-relaxed">
              Se procedió a la revisión minuciosa de todos y cada uno de los
              documentos que el candidato exhibió, mediante lo cual se considera
              lo siguiente:
            </p>
            <p className="text-xl font-semibold text-gray-800">
              ESTADO DE SALUD
            </p>

            <p className="text-justify text-gray-800 leading-relaxed">
              Considera su estado de salud{" "}
              <label
                htmlFor="nombre"
                className="text-gray-800 font-medium inline-block"
              >
                {`${queryConclusionSE.data?.estadosalud_se}`}
              </label>
              , derivado que{" "}
              <label
                htmlFor="nombre"
                className="text-gray-800 font-medium inline-block"
              >
                {`${queryConclusionSE.data?.derivado_se}`}
              </label>
              .
            </p>
            <p className="text-xl font-semibold text-gray-800">VIDA FAMILIA</p>

            <p className="text-justify text-gray-800 leading-relaxed">
              <label
                htmlFor="nombre"
                className="text-gray-800 font-medium inline-block"
              >
                {`${queryEvaluado.data?.nombre || ""} ${
                  queryEvaluado.data?.apellido_paterno || ""
                } ${queryEvaluado.data?.apellido_materno || ""}`}
              </label>{" "}
              refiere ser{" "}
              <label
                htmlFor="estado_civil"
                className="text-gray-800 font-medium inline-block"
              >
                {`${queryEvaluado.data?.estado_civil || ""}`}
              </label>
              , por el régimen de{" "}
              <label
                htmlFor="nombre"
                className="text-gray-800 font-medium inline-block"
              >
                {`${queryConclusionSE.data?.regimen_se}`}
              </label>{" "}
              cuenta con{" "}
              <label
                htmlFor="nombre"
                className="text-gray-800 font-medium inline-block"
              >
                {`${queryConclusionSE.data?.anioscasado_se}`}
              </label>{" "}
              años de{" "}
              <label
                htmlFor="estado_civil"
                className="text-gray-800 font-medium inline-block"
              >
                {`${queryEvaluado.data?.estado_civil || ""}`}
              </label>
              , tiene{" "}
              <label
                htmlFor="nombre"
                className="text-gray-800 font-medium inline-block"
              >
                {`${queryEvaluado.data?.cuantos_hijos || 0}`}
              </label>{" "}
              {Number(queryEvaluado.data?.cuantos_hijos) === 1
                ? "hijo"
                : "hijos"}
              {Number(queryEvaluado.data?.cuantos_hijos) > 0 && (
                <>
                  {" "}
                  de{" "}
                  <label
                    htmlFor="nombre"
                    className="text-gray-800 font-medium inline-block"
                  >
                    {[
                      queryEvaluado.data?.edad_hijo1,
                      queryEvaluado.data?.edad_hijo2,
                      queryEvaluado.data?.edad_hijo3,
                      queryEvaluado.data?.edad_hijo4,
                    ]
                      .filter((edad) => edad !== null && edad !== undefined)
                      .join(", ")}
                  </label>{" "}
                  años de edad,
                </>
              )}{" "}
              tiene{" "}
              <label
                htmlFor="nombre"
                className="text-gray-800 font-medium inline-block"
              >
                {`${queryConclusionSE.data?.numdependientes_se}`}
              </label>{" "}
              dependientes económicos, siendo estos{" "}
              <label
                htmlFor="nombre"
                className="text-gray-800 font-medium inline-block"
              >
                {`${queryConclusionSE.data?.quienesdependen_se}`}
              </label>
              .
            </p>
            <div className="mt-2 flex items-center gap-4">
              {/* Firma Realizó */}
              <div className="flex items-center gap-2">
                <Label
                  htmlFor="firmaRealizo"
                  className="text-sm font-semibold whitespace-nowrap"
                >
                  Firma Realizó:
                </Label>
                <TextInput
                  id="firmaRealizo"
                  name="firmaRealizo"
                  className="w-48 rounded-md py-1 text-sm"
                />
              </div>

              {/* Firma Revisó */}
              <div className="flex items-center gap-2">
                <Label
                  htmlFor="firmaReviso"
                  className="text-sm font-semibold whitespace-nowrap"
                >
                  Firma Revisó:
                </Label>
                <TextInput
                  id="firmaReviso"
                  name="firmaReviso"
                  className="w-48 rounded-md py-1 text-sm"
                />
              </div>
            </div>
            <br />
            <br />
            <p className="text-xl font-semibold text-gray-800">
              AMBITO LABORAL
            </p>

            <p className="text-justify text-gray-800 leading-relaxed">
              Manifiesta que labora en la empresa{" "}
              <label
                htmlFor="empresa"
                className="text-gray-800 font-medium inline-block"
              >
                {`${queryEvaluado.data?.empresa_id?.nombre || ""}`}
              </label>{" "}
              desde hace{" "}
              <label
                htmlFor="empresa"
                className="text-gray-800 font-medium inline-block"
              >
                {`${queryEvaluado.data?.antiguedad || ""}`}
              </label>{" "}
              y pertenece al área de{" "}
              <label
                htmlFor="empresa"
                className="text-gray-800 font-medium inline-block"
              >
                {`${queryEvaluado.data?.puesto || ""}`}
              </label>
              , ingresó a laborar el{" "}
              <label
                htmlFor="empresa"
                className="text-gray-800 font-medium inline-block"
              >
                {queryEvaluado.data?.fecha_ingreso
                  ? new Date(
                      queryEvaluado.data.fecha_ingreso
                    ).toLocaleDateString("es-ES")
                  : ""}
              </label>
              , refiere que no cuenta con familiares laborando en la empresa, en
              el momento que ingresó.
            </p>
            <p className="text-justify text-gray-800 leading-relaxed">
              Se enteró de la vacante por{" "}
              <label
                htmlFor="nombre"
                className="text-gray-800 font-medium inline-block"
              >
                {`${queryConclusionSE.data?.enterovacante_se}`}
              </label>{" "}
              , y lo recomendó{" "}
              <label
                htmlFor="nombre"
                className="text-gray-800 font-medium inline-block"
              >
                {`${queryConclusionSE.data?.recomendo_se}`}
              </label>{" "}
              .
            </p>
            <p className="text-xl font-semibold text-gray-800">
              DISTRIBUCION DE GASTOS
            </p>

            {/* Tabla de distribución mensual de gastos */}
            <div className="w-full overflow-x-auto">
              <table className="table-auto border-collapse border border-gray-300 w-full">
                {/* Header */}
                <thead>
                  <tr>
                    <th
                      className="border border-gray-300 px-4 py-2 bg-gray-100 text-center text-gray-700 font-semibold"
                      colSpan={2}
                    >
                      DISTRIBUCION MENSUAL DE GASTOS
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {/* Filas */}
                  <tr>
                    <td className="border border-gray-300 px-4 py-2 text-gray-700">
                      Alimentación
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      <input
                        value={`$ ${queryConclusionSE.data?.gastoalimentacion_se}`}
                        disabled={true}
                        type="numeric"
                        className="border border-gray-300 px-4 py-2 rounded-md w-auto inline-block text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                        placeholder="$1,000"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td className="border border-gray-300 px-4 py-2 text-gray-700">
                      Vestido y Calzado
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      <input
                        value={`$ ${queryConclusionSE.data?.gastovestido_se}`}
                        disabled={true}
                        type="numeric"
                        className="border border-gray-300 px-4 py-2 rounded-md w-auto inline-block text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                        placeholder="$1,000"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td className="border border-gray-300 px-4 py-2 text-gray-700">
                      Gasolina
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      <input
                        value={`$ ${queryConclusionSE.data?.gastogasolina_se}`}
                        disabled={true}
                        type="numeric"
                        className="border border-gray-300 px-4 py-2 rounded-md w-auto inline-block text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                        placeholder="$1,000"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td className="border border-gray-300 px-4 py-2 text-gray-700">
                      Transporte
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      <input
                        value={`$ ${queryConclusionSE.data?.gastotransporte_se}`}
                        disabled={true}
                        type="numeric"
                        className="border border-gray-300 px-4 py-2 rounded-md w-auto inline-block text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                        placeholder="$1,000"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td className="border border-gray-300 px-4 py-2 text-gray-700">
                      Teléfono
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      <input
                        value={`$ ${queryConclusionSE.data?.gastotelefono_se}`}
                        disabled={true}
                        type="numeric"
                        className="border border-gray-300 px-4 py-2 rounded-md w-auto inline-block text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                        placeholder="$1,000"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td className="border border-gray-300 px-4 py-2 text-gray-700">
                      Diversiones
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      <input
                        value={`$ ${queryConclusionSE.data?.gastodiversiones_se}`}
                        disabled={true}
                        type="numeric"
                        className="border border-gray-300 px-4 py-2 rounded-md w-auto inline-block text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                        placeholder="$1,000"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td className="border border-gray-300 px-4 py-2 text-gray-700">
                      Autofinanciamiento
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      <input
                        id="gastoautofinanciamiento_se"
                        value={`$ ${queryConclusionSE.data?.gastoautofinanciamiento_se}`}
                        disabled={true}
                        type="numeric"
                        className="border border-gray-300 px-4 py-2 rounded-md w-auto inline-block text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                        placeholder="$1,000"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td className="border border-gray-300 px-4 py-2 text-gray-700">
                      Otros
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      <input
                        value={`$ ${queryConclusionSE.data?.gastootros1_se}`}
                        disabled={true}
                        type="numeric"
                        className="border border-gray-300 px-4 py-2 rounded-md w-auto inline-block text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                        placeholder="$1,000"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
              <div>
                <div className="mt-[150px]"></div>
                <div className="mt-2 flex items-center gap-4">
                  {/* Firma Realizó */}
                  <div className="flex items-center gap-2">
                    <Label
                      htmlFor="firmaRealizo"
                      className="text-sm font-semibold whitespace-nowrap"
                    >
                      Firma Realizó:
                    </Label>
                    <TextInput
                      id="firmaRealizo"
                      name="firmaRealizo"
                      className="w-[150px] rounded-md py-1 text-sm"
                    />
                  </div>

                  {/* Firma Revisó */}
                  <div className="flex items-center gap-2">
                    <Label
                      htmlFor="firmaReviso"
                      className="text-sm font-semibold whitespace-nowrap"
                    >
                      Firma Revisó:
                    </Label>
                    <TextInput
                      id="firmaReviso"
                      name="firmaReviso"
                      className="w-[150px] rounded-md py-1 text-sm"
                    />
                  </div>
                </div>
              </div>
              <table className="table-auto border-collapse border border-gray-300 w-full">
                <tbody>
                  {/* Filas */}
                  <tr>
                    <td className="border border-gray-300 px-4 py-2 text-gray-700">
                      Hipoteca
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      <input
                        value={`$ ${queryConclusionSE.data?.gastohipoteca_se}`}
                        disabled={true}
                        type="numeric"
                        className="border border-gray-300 px-4 py-2 rounded-md w-auto inline-block text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                        placeholder="$1,000"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td className="border border-gray-300 px-4 py-2 text-gray-700">
                      Renta
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      <input
                        value={`$ ${queryConclusionSE.data?.gastorenta_se}`}
                        disabled={true}
                        type="numeric"
                        className="border border-gray-300 px-4 py-2 rounded-md w-auto inline-block text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                        placeholder="$1,000"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td className="border border-gray-300 px-4 py-2 text-gray-700">
                      Colegiaturas
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      <input
                        value={`$ ${queryConclusionSE.data?.gastocolegiaturas_se}`}
                        disabled={true}
                        type="numeric"
                        className="border border-gray-300 px-4 py-2 rounded-md w-auto inline-block text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                        placeholder="$1,000"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td className="border border-gray-300 px-4 py-2 text-gray-700">
                      Servicios
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      <input
                        value={`$ ${queryConclusionSE.data?.gastoservicios_se}`}
                        disabled={true}
                        type="numeric"
                        className="border border-gray-300 px-4 py-2 rounded-md w-auto inline-block text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                        placeholder="$1,000"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td className="border border-gray-300 px-4 py-2 text-gray-700">
                      Deudas
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      <input
                        value={`$ ${queryConclusionSE.data?.gastodeudas_se}`}
                        disabled={true}
                        type="numeric"
                        className="border border-gray-300 px-4 py-2 rounded-md w-auto inline-block text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                        placeholder="$1,000"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td className="border border-gray-300 px-4 py-2 text-gray-700">
                      Inversiones
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      <input
                        value={`$ ${queryConclusionSE.data?.gastoinversiones_se}`}
                        disabled={true}
                        type="numeric"
                        className="border border-gray-300 px-4 py-2 rounded-md w-auto inline-block text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                        placeholder="$1,000"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td className="border border-gray-300 px-4 py-2 text-gray-700">
                      Pensión Alimenticia
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      <input
                        id="gastopension_se"
                        value={`$ ${queryConclusionSE.data?.gastopension_se}`}
                        disabled={true}
                        type="numeric"
                        className="border border-gray-300 px-4 py-2 rounded-md w-auto inline-block text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                        placeholder="$1,000"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td className="border border-gray-300 px-4 py-2 text-gray-700">
                      Otros
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      <input
                        id="gastootros2_se"
                        value={`$ ${queryConclusionSE.data?.gastootros2_se}`}
                        disabled={true}
                        type="numeric"
                        className="border border-gray-300 px-4 py-2 rounded-md w-auto inline-block text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                        placeholder="$1,000"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td className="border border-gray-300 px-4 py-2 text-gray-700">
                      Total
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      <input
                        id="gastototal_se"
                        disabled={true}
                        type="text"
                        className="border border-gray-300 px-4 py-2 rounded-md w-auto inline-block text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                        placeholder="$0.00"
                        value={`$ ${totalGastos}`}
                        readOnly
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p className="text-xl font-semibold text-gray-800">
              INGRESOS Y EGRESOS
            </p>
            <p className="text-justify text-gray-800 leading-relaxed">
              En la entrevista refirió que su ingreso mensual familiar es de
              aproximadamente{" "}
              <label
                htmlFor="nombre"
                className="text-gray-800 font-medium inline-block"
              >
                {`$ ${queryConclusionSE.data?.ingresomensual_se}`}
              </label>{" "}
              , esta compuesto por{" "}
              <label
                htmlFor="nombre"
                className="text-gray-800 font-medium inline-block"
              >
                {`$ ${queryConclusionSE.data?.compuestopor_se}`}
              </label>
              , también señala que el ingreso de su esposa es de{" "}
              <label
                htmlFor="nombre"
                className="text-gray-800 font-medium inline-block"
              >
                {`$ ${queryConclusionSE.data?.ingresoesposa_se}`}
              </label>{" "}
              sus ingresos extras se componen de{" "}
              <label
                htmlFor="nombre"
                className="text-gray-800 font-medium inline-block"
              >
                {`$ ${queryConclusionSE.data?.ingresosextra_se}`}
              </label>{" "}
              y ascienden a{" "}
              <label
                htmlFor="nombre"
                className="text-gray-800 font-medium inline-block"
              >
                {`$ ${queryConclusionSE.data?.ascienden_se || ""}`}
              </label>
              .
            </p>
            <p className="text-justify text-gray-800 leading-relaxed">
              También menciona que sus egresos familiares son de{" "}
              <label
                htmlFor="nombre"
                className="text-gray-800 font-medium inline-block"
              >
                {`$ ${queryConclusionSE.data?.egresosfam_se}`}
              </label>{" "}
              y están compuestos de{" "}
              <label
                htmlFor="nombre"
                className="text-gray-800 font-medium inline-block"
              >
                {`${queryConclusionSE.data?.compuestosde_se}`}
              </label>{" "}
              y el de su esposa es de{" "}
              <label
                htmlFor="nombre"
                className="text-gray-800 font-medium inline-block"
              >
                {`$ ${queryConclusionSE.data?.esposaegreso_se}`}
              </label>
              , las deudas que tiene ascienden a{" "}
              <label
                htmlFor="nombre"
                className="text-gray-800 font-medium inline-block"
              >
                {`$ ${queryConclusionSE.data?.deudasascienden1_se}`}
              </label>
              , los gastos son de aproximadamente{" "}
              <label
                htmlFor="nombre"
                className="text-gray-800 font-medium inline-block"
              >
                {`$ ${queryConclusionSE.data?.gastosaprox_se}`}
              </label>
              .
            </p>
            <p className="text-xl font-semibold text-gray-800">DEUDAS</p>
            <p className="text-justify text-gray-800 leading-relaxed">
              Refiere que sus deudas ascienden a{" "}
              <label
                htmlFor="nombre"
                className="text-gray-800 font-medium inline-block"
              >
                {`$ ${queryConclusionSE.data?.deudasascienden2_se}`}
              </label>
              .
            </p>
            <div className="mt-2 flex items-center gap-4">
              {/* Firma Realizó */}
              <div className="flex items-center gap-2">
                <Label
                  htmlFor="firmaRealizo"
                  className="text-sm font-semibold whitespace-nowrap"
                >
                  Firma Realizó:
                </Label>
                <TextInput
                  id="firmaRealizo"
                  name="firmaRealizo"
                  className="w-48 rounded-md py-1 text-sm"
                />
              </div>

              {/* Firma Revisó */}
              <div className="flex items-center gap-2">
                <Label
                  htmlFor="firmaReviso"
                  className="text-sm font-semibold whitespace-nowrap"
                >
                  Firma Revisó:
                </Label>
                <TextInput
                  id="firmaReviso"
                  name="firmaReviso"
                  className="w-48 rounded-md py-1 text-sm"
                />
              </div>
            </div>
            <br />
            <br />
            <p className="text-xl font-semibold text-gray-800">
              VEHICULOS E INMUEBLES
            </p>

            <p className="text-justify text-gray-800 leading-relaxed">
              Durante la entrevista señalo que tiene{" "}
              <label
                htmlFor="nombre"
                className="text-gray-800 font-medium inline-block"
              >
                {`${queryConclusionSE.data?.cuantosvehiculos_se}`}
              </label>{" "}
              vehículo(s){" "}
              <label
                htmlFor="nombre"
                className="text-gray-800 font-medium inline-block"
              >
                {`${queryConclusionSE.data?.descripcionvehiculos}`}
              </label>{" "}
              , lo adquirió{" "}
              <label
                htmlFor="nombre"
                className="text-gray-800 font-medium inline-block"
              >
                {`${queryConclusionSE.data?.comoadquirio2_se}`}
              </label>
              .
            </p>
            <p className="text-xl font-semibold text-gray-800">
              ASPECTOS LEGALES
            </p>

            <p className="text-justify text-gray-800 leading-relaxed">
              Se le cuestiono al evaluado por problemas legales de cualquier
              índole que hubiera tenido.
            </p>

            <p className="text-justify text-gray-800 leading-relaxed">
              Negó haber demandado laboralmente a cualquiera de sus anteriores
              empleadores. Negó haber sido sujeto de investigaciones
              ministeriales averiguaciones previas o carpetas de investigación o
              judiciales en materia penal. Negó contar con procedimientos
              administrativos. Negó haber sido parte en juicios civiles o
              mercantiles.
            </p>
            <p className="text-xl font-semibold text-gray-800">DOMICILIO</p>

            <p className="text-justify text-gray-800 leading-relaxed">
              Refiere que su domicilio actual es{" "}
              <label
                htmlFor="domicilio"
                className="text-gray-800 font-medium inline-block"
              >
                {`${queryEvaluado.data?.calle || ""}, ${
                  queryEvaluado.data?.numero_exterior || ""
                }, ${queryEvaluado.data?.colonia || ""}, ${
                  queryEvaluado.data?.codigo_postal || ""
                }, ${queryEvaluado.data?.municipio || ""}, ${
                  queryEvaluado.data?.estado || ""
                }, ${queryEvaluado.data?.pais || ""}`}
              </label>
              , que tiene viviendo{" "}
              <label
                htmlFor="nombre"
                className="text-gray-800 font-medium inline-block"
              >
                {`${queryConclusionSE.data?.tiempoviviendo_se}`}
              </label>{" "}
              años en ese inmueble, que el inmueble es{" "}
              <label
                htmlFor="nombre"
                className="text-gray-800 font-medium inline-block"
              >
                {queryConclusionSE.data?.domicilioactual_se || ""}
              </label>
              .
            </p>

            <p className="text-justify text-gray-800 leading-relaxed">
              Manifiesta llevar una buena relación con sus vecinos, aunque no
              los trata mucho.
            </p>

            <p className="text-justify text-gray-800 leading-relaxed">
              Señala a dos referencias vecinales{" "}
              <label
                htmlFor="nombre"
                className="text-gray-800 font-medium inline-block"
              >
                {`${queryConclusionSE.data?.referenciavecinal1_se}`}
              </label>{" "}
              y{" "}
              <label
                htmlFor="nombre"
                className="text-gray-800 font-medium inline-block"
              >
                {`${queryConclusionSE.data?.referenciavecinal2_se}`}
              </label>
              .
            </p>
            <p className="text-xl font-semibold text-gray-800">
              INFORMACIÓN BANCARIA
            </p>

            <p className="text-justify text-gray-800 leading-relaxed">
              Indica que es titular de la cuenta bancaria{" "}
              <label
                htmlFor="nombre"
                className="text-gray-800 font-medium inline-block"
              >
                {queryConclusionSE.data?.titularcuentabanco_se || ""}
              </label>{" "}
            </p>
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <div className="mt-2 flex items-center gap-4">
              {/* Firma Realizó */}
              <div className="flex items-center gap-2">
                <Label
                  htmlFor="firmaRealizo"
                  className="text-sm font-semibold whitespace-nowrap"
                >
                  Firma Realizó:
                </Label>
                <TextInput
                  id="firmaRealizo"
                  name="firmaRealizo"
                  className="w-48 rounded-md py-1 text-sm"
                />
              </div>

              {/* Firma Revisó */}
              <div className="flex items-center gap-2">
                <Label
                  htmlFor="firmaReviso"
                  className="text-sm font-semibold whitespace-nowrap"
                >
                  Firma Revisó:
                </Label>
                <TextInput
                  id="firmaReviso"
                  name="firmaReviso"
                  className="w-48 rounded-md py-1 text-sm"
                />
              </div>
            </div>
            <p className="text-xl font-semibold text-gray-800">
              HABITOS Y ESPARCIMIENTO
            </p>

            <p className="text-justify text-gray-800 leading-relaxed">
              Comentó que en su tiempo libre prefiere{" "}
              <label
                htmlFor="nombre"
                className="text-gray-800 font-medium inline-block"
              >
                {`${queryConclusionSE.data?.tiempolibre_se}`}
              </label>
              . Indicó no pertenecer a ningún club social o practicar algún
              deporte.
            </p>
            <p className="text-justify text-gray-800 leading-relaxed">
              También señala que{" "}
              <label
                htmlFor="nombre"
                className="text-gray-800 font-medium inline-block"
              >
                {`${queryConclusionSE.data?.fuma_se === "true" ? "Sí" : "No"}`}
              </label>{" "}
              fuma, el consume{" "}
              <label
                htmlFor="nombre"
                className="text-gray-800 font-medium inline-block"
              >
                {`${queryConclusionSE.data?.cuantofuma_se}`}
              </label>{" "}
              al día, que{" "}
              <label
                htmlFor="nombre"
                className="text-gray-800 font-medium inline-block"
              >
                {`${queryConclusionSE.data?.toma_se === "true" ? "Sí" : "No"}`}
              </label>{" "}
              consume bebidas alcohólicas cada
              <label
                htmlFor="nombre"
                className="text-gray-800 font-medium inline-block"
              >
                {`${queryConclusionSE.data?.cuantotoma_se}`}
              </label>{" "}
              dias, siendo la ultima vez el{" "}
              <label
                htmlFor="nombre"
                className="text-gray-800 font-medium inline-block"
              >
                {`${
                  queryConclusionSE.data?.ultimavez_se
                    ? new Date(
                        queryConclusionSE.data.ultimavez_se + "T00:00:00"
                      ).toLocaleDateString("es-ES")
                    : "Fecha no disponible"
                }`}
              </label>
              ,{" "}
              <label
                htmlFor="nombre"
                className="text-gray-800 font-medium inline-block"
              >
                {`${
                  queryConclusionSE.data?.consumedrogas_se === "true"
                    ? "Sí"
                    : "No"
                }`}
              </label>{" "}
              consume drogas
              <Controller
                name="drogasdescripcion_se"
                control={control}
                defaultValue={
                  queryConclusionSE.data?.drogasdescripcion_se || ""
                }
                render={({ field }) => {
                  return (
                    <textarea
                      {...field}
                      id="drogasdescripcion_se"
                      disabled={true}
                      className="w-full p-4 min-h-[150px] text-sm text-gray-900 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 placeholder-gray-400 resize-none"
                      aria-label="drogasdescripcion_se"
                      placeholder="Explica..."
                    />
                  );
                }}
              />
            </p>
            <p className="text-xl font-semibold text-gray-800">
              EXPERIENCIA LABORAL
            </p>

            <p className="text-justify text-gray-800 leading-relaxed">
              En este rubro, se describirá detalladamente su experiencia laboral
              desde el año a la{" "}
              <label
                htmlFor="nombre"
                className="text-gray-800 font-medium inline-block"
              >
                {queryConclusionSE.data?.aniolaboral_se || ""}
              </label>{" "}
              a la fecha.
              <Controller
                name="externo1_se"
                control={control}
                defaultValue={queryConclusionSE.data?.externo1_se || ""}
                render={({ field }) => {
                  return (
                    <textarea
                      {...field}
                      id="externo1_se"
                      disabled={true}
                      className="w-full p-4 min-h-[150px] text-sm text-gray-900 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 placeholder-gray-400 resize-none"
                      aria-label="externo1_se"
                      placeholder="Explica..."
                    />
                  );
                }}
              />
            </p>
            <p className="text-justify text-gray-800 leading-relaxed">
              <label
                htmlFor="nombre"
                className="text-gray-800 font-medium inline-block"
              >
                {`${queryEvaluado.data?.nombre || ""} ${
                  queryEvaluado.data?.apellido_paterno || ""
                } ${queryEvaluado.data?.apellido_materno || ""}`}
              </label>{" "}
              externó que en tiempos inactivos laboró como chofer de manera
              independiente desde{" "}
              <label
                htmlFor="nombre"
                className="text-gray-800 font-medium inline-block"
              >
                {queryConclusionSE.data?.tiempolaborando1_se
                  ? new Date(
                      new Date(
                        queryConclusionSE.data?.tiempolaborando1_se
                      ).setDate(
                        new Date(
                          queryConclusionSE.data?.tiempolaborando1_se
                        ).getDate() + 1
                      )
                    ).toLocaleDateString("es-ES")
                  : ""}
              </label>{" "}
              hasta{" "}
              <label
                htmlFor="nombre"
                className="text-gray-800 font-medium inline-block"
              >
                {queryConclusionSE.data?.tiempolaborando2_se
                  ? new Date(
                      new Date(
                        queryConclusionSE.data?.tiempolaborando2_se
                      ).setDate(
                        new Date(
                          queryConclusionSE.data?.tiempolaborando2_se
                        ).getDate() + 1
                      )
                    ).toLocaleDateString("es-ES")
                  : ""}
              </label>
              .
            </p>
            <p className="text-justify text-gray-800 leading-relaxed">
              <label
                htmlFor="nombre"
                className="text-gray-800 font-medium inline-block"
              >
                {`${queryEvaluado.data?.nombre || ""} ${
                  queryEvaluado.data?.apellido_paterno || ""
                } ${queryEvaluado.data?.apellido_materno || ""}`}
              </label>{" "}
              señaló haber laborado como Chofer Ejecutivo, bajo la supervisión
              de{" "}
              <label
                htmlFor="nombre"
                className="text-gray-800 font-medium inline-block"
              >
                {queryConclusionSE.data?.supervision_se || ""}
              </label>{" "}
              Coordinadora de Asesores{" "}
              <label
                htmlFor="nombre"
                className="text-gray-800 font-medium inline-block"
              >
                {queryConclusionSE.data?.telcoordinadora_se || ""}
              </label>
              , quien indicó que candidato cumplió con las expectativas del
              puesto porque es una persona responsable, respetuosa, confiable,
              con disposición, puntual, discreta, amable, respetuoso, buen
              manejo ante el estrés y sabe trabajar bajo presión, no obstante,
              considera que debe tomar un curso de manejo defensivo; corrobora
              una estancia de aproximadamente 1 año como Asistente
              Administrativo / Chofer ejecutivo y salió por reestructura
              Administrativa. Se ubicó el número{" "}
              <label
                htmlFor="nombre"
                className="text-gray-800 font-medium inline-block"
              >
                {queryConclusionSE.data?.telsinexito_se || ""}
              </label>{" "}
              sin tener éxito.{" "}
              <label
                htmlFor="nombre"
                className="text-gray-800 font-medium inline-block"
              >
                {`${queryEvaluado.data?.nombre || ""} ${
                  queryEvaluado.data?.apellido_paterno || ""
                } ${queryEvaluado.data?.apellido_materno || ""}`}
              </label>{" "}
              externó que{" "}
              <label
                htmlFor="nombre"
                className="text-gray-800 font-medium inline-block"
              >
                {queryConclusionSE.data?.externo2_se || ""}
              </label>
              .
            </p>
            <div className="mt-2 flex items-center gap-4">
              {/* Firma Realizó */}
              <div className="flex items-center gap-2">
                <Label
                  htmlFor="firmaRealizo"
                  className="text-sm font-semibold whitespace-nowrap"
                >
                  Firma Realizó:
                </Label>
                <TextInput
                  id="firmaRealizo"
                  name="firmaRealizo"
                  className="w-48 rounded-md py-1 text-sm"
                />
              </div>

              {/* Firma Revisó */}
              <div className="flex items-center gap-2">
                <Label
                  htmlFor="firmaReviso"
                  className="text-sm font-semibold whitespace-nowrap"
                >
                  Firma Revisó:
                </Label>
                <TextInput
                  id="firmaReviso"
                  name="firmaReviso"
                  className="w-48 rounded-md py-1 text-sm"
                />
              </div>
            </div>
            <p className="text-xl font-semibold text-gray-800">
              CONDUCTA EN EL EXAMEN
            </p>

            <p className="text-justify text-gray-800 leading-relaxed">
              Al momento de realizar la evaluación, mencionó estar en buen
              estado de salud, psicológico y emocional para llevar a cabo la
              evaluación, por lo que durante la entrevista manifestó entender de
              manera clara y oportuna los cuestionamientos que se le realizaron;
              cabe señalar que durante el examen aseveró presentarse de manera
              voluntaria asentado su consentimiento mediante la firma del
              formato de autorización, aunado a lo anterior acató de manera
              clara y precisa las indicaciones que se le proporcionaron, durante
              la entrevista se mostró amable y participativo, por lo que la
              prueba se concluyó sin problema alguno.{" "}
            </p>
            <p className="text-xl font-semibold text-gray-800">OBSERVACIONES</p>
            <Controller
              name="observaciones_se"
              control={control}
              defaultValue={queryConclusionSE.data?.observaciones_se || ""}
              render={({ field }) => {
                return (
                  <textarea
                    {...field}
                    id="observaciones_se"
                    disabled={true}
                    className="w-full p-4 min-h-[150px] text-sm text-gray-900 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 placeholder-gray-400 resize-none"
                    aria-label="observaciones_se"
                    placeholder="Escribe tus observaciones aquí..."
                  />
                );
              }}
            />
          </div>

          <div className="grid grid-cols-1 gap-4">
            {/* Campo Resultado */}
            <div className="col-span-1">
              <Label htmlFor="rfc">RESULTADO:</Label>
              <Controller
                name="resultado_conclusion"
                control={control}
                defaultValue={
                  queryResultadoSE.data && queryResultadoSE.data.length > 0
                    ? queryResultadoSE.data[0]?.resultado_conclusion || ""
                    : ""
                }
                render={({ field }) => {
                  return (
                    <TextInput
                      {...field}
                      id="resultado_conclusion"
                      disabled={true}
                      type="text"
                      className="text-center w-full"
                      placeholder="Resultado..."
                    />
                  );
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <br />
      <br />
      <div className="grid grid-cols-2 gap-2">
        {/* FIRMA REALIZÓ */}
        <div className="col-span-1">
          <Label htmlFor="FirmaRealizo">FIRMA REALIZÓ:</Label>
          <TextInput id="FirmaRealizo" name="FirmaRealizo" disabled={true} />
        </div>
        {/* FIRMA REVISÓ */}
        <div className="col-span-1">
          <Label htmlFor="FirmaReviso">FIRMA REVISÓ:</Label>
          <TextInput id="FirmaReviso" name="FirmaReviso" disabled={true} />
        </div>
      </div>
    </div>
  );
};
